import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function(value) {
  const [t] = useTranslation();
  const options = useMemo(
    () => [
      { label: '', value: '', key: '' },
      { label: t('common.male'), value: 'Male', key: 'male' },
      { label: t('common.female'), value: 'Female', key: 'female' }
    ],
    []
  );
  const valueOption = useMemo(() => [options.find(o => o.value === value)], [value]);

  return [options, valueOption];
}
